/**
 * Due to url length limits we need to make sure the include only array does not exceed
 * 4k characters. We do a depth first unwinding of include only until the length of the array
 * is acceptable.
 *
 * We also use this as the threshold that we give before sending a sentry warning for GET
 * requests that have a too big URL.
 * We start logging warning at 88.9% of 4500 chars, which is considered a safe
 * maximum length for URLs that edge supports.
 */
export const MAX_INCLUDE_ONLY = 4000;

export const ROOT_PATH = 'ROOT';

// '%2c'.length
export const ENCODE_URL_OVERHEAD = 3;
